/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ActiveQuizUserDto = {
  /**
   * 유저 ID
   */
  userId: number;
  /**
   * 풀이 종류 (quizPack | tournament | vocab | exam)
   */
  kind: ActiveQuizUserDto.kind;
  /**
   * 닉네임
   */
  nickname: string;
  /**
   * 프로필 이미지 URL
   */
  profileImageUrl?: string;
  /**
   * 문제집 ID
   */
  quizPackId: string;
  /**
   * 문제집 제목
   */
  quizPackTitle: string;
  /**
   * 푼 문제 수
   */
  solvedCount: number;
  /**
   * 전체 문제 수
   */
  totalCount: number;
  /**
   * 획득 마일리지
   */
  earnedMileage: number;
  /**
   * 마지막 활동 시간
   */
  lastActiveAt: string;
};
export namespace ActiveQuizUserDto {
  /**
   * 풀이 종류 (quizPack | tournament | vocab | exam)
   */
  export enum kind {
    QUIZ_PACK = "quizPack",
    TOURNAMENT = "tournament",
    VOCAB = "vocab",
    EXAM = "exam",
  }
}
